import { useSelector } from 'react-redux';
import partialRight from 'lodash/partialRight';
import { getIsFocusRequested } from '../redux/selectors';
export function useShouldFocus(editorId) {
    return useSelector(partialRight(getIsFocusRequested, editorId, false));
}

//# sourceMappingURL=useShouldFocus.js.map